<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'AppComponent'
}
</script>
<style lang="scss">
@import "@fortawesome/fontawesome-free/css/all.min.css";
@import "bootstrap-icons/font/bootstrap-icons.css";
@import "assets/sass/element-ui.dark";
@import "assets/sass/plugins";
@import "assets/sass/style";
@import '@vuepic/vue-datepicker/dist/main.css';

#app {
  display: contents;
}

.table-content-list {
  height: calc(100vh - 290px);

  &.in-modal {
    height: calc(100vh - 292px);
  }

  .dropdown-toggle {
    &::after {
      content: '';
      border: none;
    }
  }

  table {
    td {
      &.text-end {
        padding-right: .2rem !important;
      }
    }
  }
}

.aside-menu {
  height: 1px;
  overflow-x: hidden;
  overflow-y: auto;
}

</style>
